export const enableModulesPaths = {
  enableMembers: "/family-member-table",
  enableYahrzeit: "/yahrzeit",
  enableBilling: "/finance",
  enableEvents: "/events-view",
  enableEducation: "/classes",
  enableDonations: "/donation-view",
  enableSettings: "/settings",
}
